module.exports = __webpack_public_path__ + "img/wingpay.6123ff32.png";